import { Box, Button, useTheme } from "@mui/material";
import { useRecordContext } from "ra-core";
import { FC, useEffect, useRef } from "react";
import { useHasPermit } from "~/authProvider/useHasPermit";
import { MANAGE_DATA_CATALOG } from "~/constants";
import { DataCatalogResponseDto } from "~/gen/api/governance";
import { useDataCatalogContext } from "../dataCatalogContext/DataCatalogContext";
import FieldEdit from "./FieldEdit";
import { FieldRecordEditContextProvider } from "./FieldRecordEditContextProvider";

const RowExpandFieldEdit: FC = () => {
  const hasDCWritePermit = useHasPermit([MANAGE_DATA_CATALOG])
  const theme = useTheme()
  const handleSubmitRef = useRef(()=>{})

  const { cancelSingleEdit } = useDataCatalogContext()
  const record = useRecordContext()
  const dto: DataCatalogResponseDto = record as any

  const dialogRef = useRef<HTMLElement|null>(null)
  useEffect(() => {
    setTimeout(() => {
      dialogRef.current?.focus()
    })
  }, [])
  return (
    <Box role="dialog">
      <span tabIndex={-1} ref={dialogRef} className="sr-only">Field Edit Region for {`${dto.databaseName}.${dto.schemaName}.${dto.tableName}.${dto.name}`}</span>
      <FieldRecordEditContextProvider>
        <FieldEdit handleSubmitRef={handleSubmitRef} />
        <Box
          sx={{
            mb: -2,
            mx: -2,
            py: '10px',
            px: 5,
            borderTop: `1px solid ${theme.palette.divider}`,
            bgcolor: 'background.default',
            '& button': {
              width: 96,
              mr: 2,
            },
          }}
        >
          {hasDCWritePermit &&
            <Button 
              variant="contained" 
              size="small" 
              color="primary"
              onClick={() => handleSubmitRef.current && handleSubmitRef.current()}
            >
              Save
            </Button>}
          <Button 
            variant="outlined" 
            size="small" 
            color="primary" 
            onClick={() => cancelSingleEdit(record)}
          >
            Cancel
          </Button>
        </Box>
      </FieldRecordEditContextProvider>
    </Box>
  )
}

export default RowExpandFieldEdit;
